import { Group, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { SmallSquareButton } from '../../../components/small-square-button/small-square-button';
import { Checkbox } from '../../../ui-library/checkbox/checkbox';
import { Divider } from '../../../ui-library/divider/divider';
import { Text } from '../../../ui-library/typography/typography';

export type DeliveryProgressFilter = {
  notStarted: boolean;
  inProgress: boolean;
  nearComplete: boolean;
  complete: boolean;
};

type Props = {
  setShow: (show: boolean) => void;
  title?: string;
  deliveryProgressFilter: DeliveryProgressFilter;
  onDeliveryProgressFilterChange: (filter: DeliveryProgressFilter) => void;
};

export function MindMapFilters({ setShow, title, deliveryProgressFilter, onDeliveryProgressFilterChange }: Props) {
  const i18n = useTranslation();
  const handleFilterChange = (key: keyof DeliveryProgressFilter) => {
    onDeliveryProgressFilterChange({
      ...deliveryProgressFilter,
      [key]: !deliveryProgressFilter[key],
    });
  };

  const allSelected =
    deliveryProgressFilter.notStarted &&
    deliveryProgressFilter.inProgress &&
    deliveryProgressFilter.nearComplete &&
    deliveryProgressFilter.complete;

  const handleToggleAll = () => {
    const newValue = !allSelected;
    onDeliveryProgressFilterChange({
      notStarted: newValue,
      inProgress: newValue,
      nearComplete: newValue,
      complete: newValue,
    });
  };

  return (
    <Stack gap={16} h="100%">
      <Group justify="space-between">
        <Text size="medium" weight="medium">
          {title || 'Filters'}
        </Text>
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
      </Group>
      <Divider />

      <Text size="small" weight="medium">
        {i18n.t('common.delivery_progress', 'Delivery Progress')}
      </Text>
      <Stack gap="sm">
        <Checkbox label={i18n.t('common.all', 'All')} checked={allSelected} onChange={handleToggleAll} />
        <Checkbox
          label={i18n.t('strategy.filters.not_started', 'Not Started (0%)')}
          checked={deliveryProgressFilter.notStarted}
          onChange={() => handleFilterChange('notStarted')}
        />
        <Checkbox
          label={i18n.t('strategy.filters.in_progress', 'In Progress (1-74%)')}
          checked={deliveryProgressFilter.inProgress}
          onChange={() => handleFilterChange('inProgress')}
        />
        <Checkbox
          label={i18n.t('strategy.filters.near_complete', 'Near Complete (75-99%)')}
          checked={deliveryProgressFilter.nearComplete}
          onChange={() => handleFilterChange('nearComplete')}
        />
        <Checkbox
          label={i18n.t('strategy.filters.complete', 'Complete (100%)')}
          checked={deliveryProgressFilter.complete}
          onChange={() => handleFilterChange('complete')}
        />
      </Stack>
    </Stack>
  );
}
